import { render, staticRenderFns } from "./MedicineList.vue?vue&type=template&id=e35596a4&scoped=true"
import script from "./MedicineList.vue?vue&type=script&lang=ts"
export * from "./MedicineList.vue?vue&type=script&lang=ts"
import style0 from "./MedicineList.vue?vue&type=style&index=0&id=e35596a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35596a4",
  null
  
)

export default component.exports